import axios from 'axios'

export const companiesGmbLocationSyncLogs = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    message: null,
  },
  mutations: {
    prepareConnect(state) {
      state.data = null
      state.meta = null
      state.loading = true
      state.loadError = false
    },
    readGmbLocationSyncLogsSuccess(state, payload) {
      state.data = payload.data
      state.meta = payload.meta
      state.loading = false
      state.loadError = false
    },
    apiFailure(state) {
      state.loading = false
      state.loadError = true
    }
  },
  actions: {
    readGmbLocationSyncLogs({ commit }, company_uuid) {
      commit('prepareConnect')
      commit('flash/clearFlash', null, { root: true })
      axios
        .get('/api/companies/' + company_uuid + '/gmb_location_sync_logs.json' + window.location.search)
        .then(res => {
          commit('readGmbLocationSyncLogsSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
  }
}
